<template>
    <div id="operations_layout">
        <div
            is="ErrorBox"
            :errors="errors"
        >
        </div>
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>

    </div>
</template>

<script>
import ErrorBox from '@core_waybills/.components/customer/errors.vue'
export default {
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
        ErrorBox
    }
}
</script>
